var render = function (_h,_vm) {var _c=_vm._c;return _vm._m(0)}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('section',[_c('img',{attrs:{"src":"/images/qr-code.svg","alt":"slides link","title":"slides-link","loading":"lazy","width":"50%","height":"50%"}})])}]

export { render, staticRenderFns }